import styles from "./style.module.scss";
import PropTypes from 'prop-types';

const AddNewAdditionalInfo = ({role, username}) => {

  return (
    <div className={styles.additionalInfosList}>
      <div className={styles.select}>
        <div className={styles.selectedType}>
          <div className={styles.select}>{role}</div>
        </div>
      </div>
      <input value={username} />
    </div>
  );
};

AddNewAdditionalInfo.propTypes = {
  username: PropTypes.string,
  selectedRole: PropTypes.string
}

AddNewAdditionalInfo.defaultProps = {
  username: 'Soufian',
  selectedRole: 'Featuring'
}

export default AddNewAdditionalInfo;
